// saga.js
import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_SOURCE_SETTINGS_NOTES,
  CREATE_SOURCE_SETTINGS_NOTES,
  UPDATE_SOURCE_SETTINGS_NOTES,
  DELETE_SOURCE_SETTINGS_NOTES,
  BULK_CREATE_SOURCE_SETTINGS_NOTES,
} from "./actionTypes";
import {
  getSourceSettingsNotesSuccess,
  getSourceSettingsNotesError,
  createSourceSettingsNotesSuccess,
  createSourceSettingsNotesError,
  updateSourceSettingsNotesSuccess,
  updateSourceSettingsNotesError,
  deleteSourceSettingsNotesSuccess,
  deleteSourceSettingsNotesError,
  bulkCreateSourceSettingsNotesSuccess,
  bulkCreateSourceSettingsNotesError,
} from "./actions";
import { genericDeleteRequest, genericGetRequest, genericPostRequest, genericPutRequest } from "helpers/sf_backend_helper";
import { AppConfiguration } from "config";
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper";

// Get Source Settings Notes
function* onGetSourceSettingsNotes(action) {
  try {
    const adminUser = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/all_source_setting_notes/${action.payload}`, //campaign id
      {},
      {
          Authorization: adminUser.token,
          "Content-Type": "application/json",
        },
    );
    yield put(getSourceSettingsNotesSuccess(response));
  } catch (error) {
    yield put(getSourceSettingsNotesError(error));
  }
}

// Create Source Settings Notes
function* onCreateSourceSettingsNotes(action) {
  try {
    const adminUser = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/source_setting_notes`, // source setting id
      {
        body: JSON.stringify({
          ...action.payload,
        }),
        headers: {
          Authorization: adminUser.token,
          "Content-Type": "application/json",
        },
      }
    );
    yield put(createSourceSettingsNotesSuccess(response));
  } catch (error) {
    yield put(createSourceSettingsNotesError(error));
  }
}

// Update Source Settings Notes
function* onUpdateSourceSettingsNotes(action) {
  try {
    const adminUser = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/source_setting_notes/${action.payload.id}`, // source setting note id
      {
        body: JSON.stringify({
          ...action.payload,
        }),
        headers: {
          Authorization: adminUser.token,
          "Content-Type": "application/json",
        },
      }
    );
    yield put(updateSourceSettingsNotesSuccess(response));
  } catch (error) {
    yield put(updateSourceSettingsNotesError(error));
  }
}

// Delete Source Settings Notes
function* onDeleteSourceSettingsNotes(action) {
  try {
    const adminUser = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/source_setting_notes/${action.payload}`, // source setting note id
      {
        method: "DELETE",
        headers: {
          Authorization: adminUser.token,
          "Content-Type": "application/json",
        },
      }
    );
    yield put(deleteSourceSettingsNotesSuccess(response));
  } catch (error) {
    yield put(deleteSourceSettingsNotesError(error));
  }
}

// Bulk Create Source Settings Notes
function* onBulkCreateSourceSettingsNotes(action) {
  try {
    const adminUser = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/bulk_create_source_setting_notes`,
      {
        body: JSON.stringify({
          ...action.payload,
        }),
        headers: {
          Authorization: adminUser.token,
          "Content-Type": "application/json",
        },
      }
    );
    yield put(bulkCreateSourceSettingsNotesSuccess(response));
  } catch (error) {
    yield put(bulkCreateSourceSettingsNotesError(error));
  }
}

function* SourceSettingsNotesSaga() {
  yield takeEvery(GET_SOURCE_SETTINGS_NOTES, onGetSourceSettingsNotes);
  yield takeEvery(CREATE_SOURCE_SETTINGS_NOTES, onCreateSourceSettingsNotes);
  yield takeEvery(UPDATE_SOURCE_SETTINGS_NOTES, onUpdateSourceSettingsNotes);
  yield takeEvery(DELETE_SOURCE_SETTINGS_NOTES, onDeleteSourceSettingsNotes);
  yield takeEvery(BULK_CREATE_SOURCE_SETTINGS_NOTES, onBulkCreateSourceSettingsNotes);
}

export default SourceSettingsNotesSaga;
